import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class CarouselService {
  private idClickedSubject = new Subject<string>();

  idClickedSubject$ = this.idClickedSubject.asObservable();

  nextId(id: string): void {
    this.idClickedSubject.next(id);
  }
}
